import { render, staticRenderFns } from "./frameworkList.vue?vue&type=template&id=02e4c764&scoped=true&"
import script from "./frameworkList.vue?vue&type=script&lang=js&"
export * from "./frameworkList.vue?vue&type=script&lang=js&"
import style0 from "./frameworkList.vue?vue&type=style&index=0&id=02e4c764&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e4c764",
  null
  
)

export default component.exports